<template>
  <div>
    <MainForm
      :name="FORM_NAMES.referralWelcome"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Striver card application"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.referralWelcome"
        ui-title="Referral Program"
        ui-error-message="Please review the fields marked in red"
        ui-button-text="GENERATE REFERRAL LINK"
      >
        <FieldsetFullName />
        <FieldsetEmail subtitle />
        <FieldsetMobilePhone title="Your mobile number is" subtitle />

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.referalFullName"
          ui-title="Full name of the person being referred"
          ui-columns="2"
        >
          <UiWrapper :name="FIELD_NAMES.referFirstName" label="Referee's First Name">
            <InputText />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.referLastName" label="Referee's Last Name">
            <InputText />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.referalEmail"
          ui-title="Email address of the person being referred"
        >
          <UiWrapper
            :name="FIELD_NAMES.referEmail"
            :validations="emailValidations"
            label="Referee's Email Address"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.referalMobileNumber"
          ui-title="Mobile number of the person being referred"
        >
          <UiWrapper
            :name="FIELD_NAMES.referMobileNumber"
            label="Referee's Mobile Number"
            :validations="validations"
          >
            <InputText type="tel" :prefix="prefix" :maxlength="maxlength" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.referralThankYou"
        :ui-title="`Referral Link`"
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.referalCashUp"
          ui-title="Share the below link with the person being 
          referred for a Deem Cash Up (Cashback) Credit Card:"
        >
          <UiWrapper :name="FIELD_NAMES.referalCashUp" >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.referalCashUpButton">
          <UiWrapper :name="FIELD_NAMES.referalCashUpButton">
            <Button type="button" :click="copyLinkCashUp" id="cashUp">Copy Link</Button>
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.referalMileUp"
          ui-title="Share the below link with the person being 
          referred for a Deem Mile Up (Travel) Credit Card:"
        >
          <UiWrapper :name="FIELD_NAMES.referalMileUp" >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.referalMileUpButton">
          <UiWrapper :name="FIELD_NAMES.referalMileUpButton">
            <Button type="button" :click="copyLinkMileUp" id="mileUp">Copy Link</Button>
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import IncomeSwitcher from "@/forms/components/ui-dunia/income-switcher";
import FieldIncome from "@/forms/components/shared/fields/income";
import FieldsetVariableIncome from "@/forms/components/shared/fields/variable-income";
import Captcha from "@/forms/captcha";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
// Constants
import {
  DIGIT_CHARS,
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  EMAIL_VALIDATION_PATTERN
} from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";
import StepOtp from "@/forms/components/shared/steps/otp";
import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetBornDate from "@/forms/components/shared/fieldsets/born-date";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetIBAN from "@/forms/components/shared/fieldsets/iban-number";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import StepOCREmirates from "@/forms/components/shared/steps/ocr-emirates";
import StepIdentityReview from "@/forms/components/shared/steps/identity-review";
import StepStatementUpload from "@/forms/components/shared/steps/upload-statements";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import {
  SET_BANK_NAME,
  SET_FIRST_NAME,
  SET_SECOND_NAME,
  SET_BASIC_ELIGIBILITY,
  SET_PRODUCT_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
  SET_VARIABLE_INCOME,
  SET_UAE_VINTAGE,
  SET_JOB_VINTAGE
} from "@/lib/constants/mutations";

import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";
const UPLOAD_FILE_NAMES = [
  FIELD_NAMES.firstSalaryFile,
  FIELD_NAMES.secondSalaryFile,
  FIELD_NAMES.thirdSalaryFile
];
export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    UploadWrapper,
    IncomeSwitcher,
    StepOtp,
    FieldsetEmail,
    FieldsetBornDate,
    FieldsetMobilePhone,
    FieldsetFullName,
    StepOCREmirates,
    StepIdentityReview,
    FieldIncome,
    InputPassword,
    CheckWrapper,
    Expandable,
    StepStatementUpload,
    Button,
    FieldsetIBAN,
    FieldsetVariableIncome,
    Captcha
  },
  props: {
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number"
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length"
        }
      ]
    },
    emailValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Please type a valid email",
          condition: conditions.patternCondition(EMAIL_VALIDATION_PATTERN),
          name: "check-is-email"
        }
      ]
    },
    prefix: {
      type: String,
      default: "+971"
    },
    maxlength: {
      type: Number,
      default: 9
    }
  },
  data: () => ({
    referalCifNumber: "",
    EMAIL_VALIDATION_PATTERN
  }),
   mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods: {
    submit(response) {
      console.log(response);
    },
    copyLinkCashUp(event) {
      event.preventDefault();
      var copyText = document.getElementsByName("referalCashUp")[0];
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },

    copyLinkMileUp(event) {
      event.preventDefault();
      var copyText = document.getElementsByName("referalMileUp")[0];
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },

    finishCallback() {
      this.showEndPage({
        title: `Thanks ${this.userName},`,
        subtitle: "you are not eligible for the referral program."
      });
    },
  
  },
  computed: {
    cashUpLink() {
      return `https://www.deem.io/cards/cash up/?utm_source=Referral&utm_medium=${localStorage.getItem(
        "referralCif"
      )}&utm_campaign=Cash Up Digital Referral`;
    },
    mileUpLink() {
      return `https://www.deem.io/cards/miles up/?utm_source=Referral&utm_medium=${localStorage.getItem(
        "referralCif"
      )}&utm_campaign=Miles Up Digital Referral`;
    },
     
  },
};
</script>

<style  scoped>
/* #cashUp{
  color:#ffffff;
}
#mileUp{
  color:#ffffff;
} */
</style>
